import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/pages/typescript';
import theme from '@styles/theme';
export default {
  container: (marginTop: TMarginsTypes, marginBottom: TMarginsTypes, bg?: string) => ({
    bg,
    pt: MARGINS_BLOCKS[marginTop],
    pb: MARGINS_BLOCKS[marginBottom],
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    width: '100%',
    maxWidth: ['100%', '100%', '478px', '903px'],
    m: '0 auto',
    table: {
      border: '1px solid #cccccc',
      width: '100%',
      tr: {
        border: 'none',
        width: '100%',
        td: {
          border: '1px solid #cccccc',
          borderLeft: 'none',
          p: '8px',
          '&:last-of-type': {
            borderRight: 'none'
          }
        }
      }
    }
  })
};